
import App from "./App";
import { MapArtworks } from "./components/map-artworks/map-artworks";
import { Contact } from "./components/contact/contact";
import { Page } from "./components/page/page";
import { PressReview } from "./components/press-review/press-review";
import { Memories } from "./components/memories/memories";
import { NotFound } from "./components/not-found/not-found";
import { DEFAULT_LANGUAGE } from "./utils/constants/languages";
import { Navigate } from "react-router-dom";
import { About } from "./components/about/about";



 export const appRoutes = [
    {
      path:'/',
      element:<Navigate to={`/${DEFAULT_LANGUAGE?.code}`} replace /> 
    },
    {
      path: "/:lang",
      element: <App />,
      children: [
        { index: true, element: <MapArtworks /> },
        { path: "map", element: <MapArtworks /> },
        { path: "contact", element: <Contact /> },
        { path: "privacy-policy", element: <Page /> },
        { path: "legal-notice", element: <Page /> },
        { path: "about", element: <About /> },
        { path: "press-review", element: <PressReview /> },
        { path: "memories", element: <Memories /> },
        { path: "not-found", element: <NotFound /> },
       { path: "*",element:<Navigate to="not-found" replace/>}

      ]
    }/*,
    { path: "*",element:<Navigate to={` ${DEFAULT_LANGUAGE?.code}/not-found`} replace/>}*/
];